import React, { useState, useEffect } from 'react';

const PaymentTimer = ({ expiresAt, onExpired }) => {
  const [timeLeft, setTimeLeft] = useState({ isExpired: false });

  useEffect(() => {
    if (!expiresAt) return;

    const calculateTimeLeft = () => {
      const now = new Date();
      const expiration = new Date(expiresAt);
      const diffMs = expiration.getTime() - now.getTime();

      if (diffMs <= 0) {
        setTimeLeft({ isExpired: true });
        if (onExpired) onExpired();
        return;
      }

      const totalSeconds = Math.floor(diffMs / 1000);
      const totalMinutes = Math.floor(totalSeconds / 60);
      const totalHours = Math.floor(totalMinutes / 60);
      const totalDays = Math.floor(totalHours / 24);
      const totalMonths = Math.floor(totalDays / 30);

      let timeDisplay = {};

      if (totalMonths >= 1) {
        timeDisplay = {
          months: totalMonths,
          days: totalDays % 30
        };
      } else if (totalDays >= 1) {
        timeDisplay = {
          days: totalDays,
          hours: totalHours % 24
        };
      } else {
        timeDisplay = {
          hours: totalHours,
          minutes: totalMinutes % 60,
          seconds: totalSeconds % 60
        };
      }

      setTimeLeft({ ...timeDisplay, isExpired: false });
    };

    // Calculate immediately
    calculateTimeLeft();

    // Update every second
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [expiresAt, onExpired]);

  if (!expiresAt || timeLeft.isExpired) {
    return (
      <div className="flex items-center text-red-600 text-sm">
        <span className="ml-1">⏰</span>
        <span>פג תוקף</span>
      </div>
    );
  }

  const isUrgent = timeLeft.hours !== undefined && timeLeft.hours === 0 && timeLeft.minutes < 2;

  return (
    <div className={`flex items-center text-sm ${isUrgent ? 'text-red-600' : 'text-yellow-600'}`}>
      <span className="ml-1">⏰</span>
      <span>
        זמן נותר: {
          timeLeft.months !== undefined ? `${timeLeft.months} חודשים ${timeLeft.days} ימים` :
          timeLeft.days !== undefined ? `${timeLeft.days} ימים ${timeLeft.hours} שעות` :
          `${timeLeft.hours}:${timeLeft.minutes?.toString().padStart(2, '0')}:${timeLeft.seconds?.toString().padStart(2, '0')}`
        }
      </span>
    </div>
  );
};

export default PaymentTimer;